<div class="layout">
    <h1 class="section-header">Home</h1>
    <section class="section section-1 no-border">
        <div class="box" [ngClass]="{ 'box-warning': box.isAlarm }" *ngFor="let box of queueMonitorData">
            <div class="box-label">{{ translateLabel(box.description) }}</div> 
            <div class="box-value"><i *ngIf="box.isAlarm" class="fa fa-exclamation-circle" style="color: #B56D02;font-size: 12px;vertical-align: middle;"></i>
                {{ getDisplayValue(box.data) }}</div>
        </div>
    </section>
    <section class="section section-2">
        <div class="traffic-header">
            <div class="left">
                <div class="title-traffic">{{ 'home:trafficToday' | i18next }}</div> 
            </div>
            <div class="right">
                <div class="title-queues">{{ 'home:queues' | i18next }}</div>
                <app-basic-dropdown id="queues-dropdown" [(model)]="selectedQueueIds" [label]="" renderAsHtml="true"
                    [items]="listQueues" bindLabel="descript" bindValue="vQueueId"
                    (modelChange)="selectedQueueIds=$event;onQueueSelectionChange()" width="300px" [multiple]="true"
                    [multiline]="false" [showSelectAll]="true" [showAllSelectedLabel]="true"
                    allSelectedLabel="All Queues">></app-basic-dropdown>
                <span class="selected-pill">
                    {{ selectedQueueIds?.length ?? 0 }} selected
                </span>
            </div>
        </div>
        <div class="chart-container" [chart]="chart"></div>
    </section>
    <div class="useful-info-section-header-row">
        <h2 class="useful-info-section-header">{{ 'home:usefulInformation' | i18next }}</h2>
        <app-basic-button *ngIf="editInformation" id="" type="secondary" size="medium" (click)="editInfoRedirect()">
            {{ 'home:editinformation_title' | i18next }}
        </app-basic-button>
        <!-- <a *ngIf="editInformation" class="header-button" [href]=editInformationUrl>
            Edit Information
        </a> -->
    </div>
    <section class="section" *ngFor="let info of productInformations">
        <div class="info-section-header">
            <div class="title">{{ decodeHtml(info.header) }}</div>
            <span class="date">{{ info.publishTimeString }}</span>
        </div>

        <div class="text-block" [innerHTML]="cleanHtml(info.body)">
        </div>
    </section>
</div>